import React from 'react';
import { Edit, useRedirect, TabbedShowLayout, Tab, ReferenceManyField, Pagination} from 'react-admin';

import { OwnerCompanyDataForm } from '../forms/OwnerCompanyDataForm';
import { SimpleFormAdv } from '../../../components/forms/SimpleFormAdv';
import { DocumentTemplateList } from 'components/DocumentTemplates';
import { DefaultDocumentTemplateType } from 'entities/DocumentTemplateType';
import Card from '@material-ui/core/Card';


export const OwnerCompanyDataEdit = (props) => {
    const redirect = useRedirect();

    const onSuccess = () => {
        redirect(props.basePath);
        window.location.reload();
    };

    const toolbarCompProps = {
		useSaveButtonEx: true,
		saveButtonExProps: { onSuccess },
	};

    return (
        <TabbedShowLayout style={{paddingBottom: 8}} basePath={props.basePath}>
            <Tab label="tab.geneneral.name" >
            <Edit {...props} undoable={false}>
                <SimpleFormAdv toolbarCompProps={toolbarCompProps}>
                    <OwnerCompanyDataForm />
                </SimpleFormAdv>
            </Edit>
            </Tab>
            <Tab label="tab.document-template-default.name" path="document-templates">
                <Card>
                    <ReferenceManyField label={false} fullWidth reference="document-templates" filter={{"type": DefaultDocumentTemplateType.invoice_template}}
                                        pagination={<Pagination rowsPerPageOptions={[5, 10, 15, 20, 25]} />} perPage={5}>
                        <DocumentTemplateList isDefaultInvoiceTeplateWithNullTerminal={true} {...props}/>
                    </ReferenceManyField>
                </Card>
            </Tab>
        </TabbedShowLayout>
    );
};
